import { useCallback } from 'react';
import { useMutation } from 'react-relay';
import graphql from 'babel-plugin-relay/macro';

import { deleteRootConnectionNode, useErrorHandler } from 'lib';
import { useDeleteMutation } from '__generated__/useDeleteMutation.graphql';

type UseDelete = [(id: string) => void, boolean];

export function useDelete(connectionID?: string): UseDelete {
  const errorHandler = useErrorHandler();

  const [runMutation, running] = useMutation<useDeleteMutation>(graphql`
    mutation useDeleteMutation($id: ID!) {
      deleteNode(id: $id)
    }
  `);

  const handleDelete = useCallback(
    (id: string) => {
      if (!connectionID) return;

      runMutation({
        variables: { id },
        ...errorHandler(),

        updater: store => {
          deleteRootConnectionNode(store, connectionID, id);
        },

        optimisticUpdater: store => {
          deleteRootConnectionNode(store, connectionID, id);
        },
      });
    },
    [connectionID, runMutation, errorHandler]
  );

  return [handleDelete, running];
}
